import { FcTodoList } from "react-icons/fc";
import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("Infographics")
    .icon(FcTodoList)
    .child(S.documentTypeList("infographicPerCruiseGroup"));
